import React, { Dispatch, SetStateAction } from 'react';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { StickyFooter } from '../../../../CommonComponents/OPL/StickyFooter/StickyFooter';
import { FinancialGoal } from '../../AutoAccountWorkflow.types';

interface StepFooterProps {
  isFirstStep: boolean;
  isLastStep: boolean;
  nextStep: Dispatch<SetStateAction<void>>;
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  previousStep: Dispatch<SetStateAction<void>>;
  progress: number;
  restartWizard: Dispatch<SetStateAction<void>>;
  validateCurrentStep: () => Promise<boolean>;
  isLoading: boolean;
  showNextButton?: boolean;
  initialActiveWorkflow: FinancialGoal | null;
}

export const StepFooter: React.FC<StepFooterProps> = ({
  isFirstStep,
  onSubmit,
  progress,
  restartWizard,
  previousStep,
  nextStep,
  isLastStep,
  validateCurrentStep,
  isLoading,
  showNextButton,
  initialActiveWorkflow,
}) => {
  return (
    <StickyFooter progress={progress}>
      {(!isFirstStep || initialActiveWorkflow === null) && (
        <>
          <Button
            variant="secondary"
            size="large"
            onClick={() => {
              if (isFirstStep) {
                restartWizard();
              } else {
                previousStep();
              }
            }}
            leftIcon="fas fa-chevron-left"
            mr="auto"
          >
            Previous
          </Button>

          <Button size="large" variant="subtleInactive" onClick={() => restartWizard()}>
            Cancel
          </Button>
        </>
      )}

      {showNextButton && (
        <Button
          size="large"
          type="button"
          isLoading={isLoading}
          onClick={async () => {
            if (await validateCurrentStep()) {
              if (isLastStep) {
                await onSubmit();
              } else {
                nextStep();
              }
            }
          }}
          rightIcon="fas fa-chevron-right"
          ml="16"
        >
          Next
        </Button>
      )}
    </StickyFooter>
  );
};
